import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import _ from 'lodash'
import React, { useContext, useMemo, useReducer } from 'react'
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext'
import { sportsStandingsHandlers, sportsStandingsInitialState, sportsStandingsReducer } from '../../cnr/reducers/SportsStandingsReducer'
import { CreatePlayoffContext } from '../../create/CreatePlayoff'
import LevelSectionStandings from './LevelSectionStandings'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import StandingsLegend from './StandingsLegend'

export const _standingsTypes = {
  section: 'section',
  team: 'team',
  match: 'match',
  playoff: 'playoff'
}

export const SportsStandingsContext = React.createContext()

const LeagueStandings = (props) => {

  const { standingType, forOverview, forPlayoff } = props

  // appUserAccess
  const appUserAccess = useAppUserAccess()
  const { favs_info } = appUserAccess ?? {}
  const { eventFavs } = favs_info ?? {};
  const _teamsFavs = eventFavs && eventFavs['teams']

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}

  const _teamKey_page = pathViews?.teams
  const _matchKey_page = pathViews?.matches

  let _standingType = standingType;

  if (_teamKey_page) {
    _standingType = _standingsTypes.team
  } else if (_matchKey_page) {
    _standingType = _standingsTypes.match
  }

  // createPlayoffContext
  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state } = createPlayoffContext ?? {}
  const { playoff_info } = createPlayoff_state ?? {}
  const { oppsOnly } = playoff_info ?? {}

  const init_state = {}
  const [sportsStandings_state, sportsStandings_dispatch] = useReducer(sportsStandingsReducer, init_state, sportsStandingsInitialState)
  const sportsStandings_handlers = useMemo(
    () => sportsStandingsHandlers(sportsStandings_dispatch),
    [sportsStandings_dispatch]
  );

  const {
    noData,
    selectedLevelKey,
    selectedTeamLevel,
    selectedTeams,
    selectedTeamSection,
    showPlayoffPicture,
  } = sportsStandings_state ?? {}

  const standingsLegend = useMemo(() => {
    if (forOverview || forPlayoff) return null;
    return (
      <StandingsLegend />
    );
  }, []);

  return <SportsStandingsContext.Provider value={{ sportsStandings_state, sportsStandings_handlers }}>
    <div>
      <LevelSectionStandings
        _matchKey_page={_matchKey_page}
        _standingType={_standingType}
        _teamKey_page={_teamKey_page}
        _teamsFavs={_teamsFavs}
        forOverview={forOverview}
        forPlayoff={forPlayoff}
        noData={noData}
        oppsOnly={oppsOnly}
        selectedLevelKey={selectedLevelKey}
        selectedTeamLevel={selectedTeamLevel}
        selectedTeams={selectedTeams}
        selectedTeamSection={selectedTeamSection}
        showPlayoffPicture={showPlayoffPicture}
      />
      {standingsLegend}
    </div>
  </SportsStandingsContext.Provider>

}

export default LeagueStandings